module.exports = __webpack_public_path__ + "static/media/animation.a49d71b1.svg";